import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  const { t, i18n } = useTranslation();
  const isEnglish = i18n.language === 'en';
  const prefix = isEnglish ? '/en' : '';

  const quickLinks = [
    { to: isEnglish ? `${prefix}/services` : `${prefix}/servicios`, label: t('nav.services') },
    { to: isEnglish ? `${prefix}/about` : `${prefix}/nosotros`, label: t('nav.about') },
    { to: `${prefix}/faq`, label: 'FAQ' },
    { to: isEnglish ? `${prefix}/contact` : `${prefix}/contacto`, label: t('nav.contact') },
  ];

  const serviceLinks = [
    {
      to: isEnglish ? `${prefix}/services/major-medical` : `${prefix}/servicios/gastos-medicos-mayores`,
      label: t('services.majorMedical.title')
    },
    {
      to: isEnglish ? `${prefix}/services/life-insurance` : `${prefix}/servicios/seguro-de-vida`,
      label: t('services.life.title')
    },
    {
      to: isEnglish ? `${prefix}/services/bonds` : `${prefix}/servicios/fianzas`,
      label: t('services.bonds.title')
    },
    {
      to: isEnglish ? `${prefix}/services/travel-insurance` : `${prefix}/servicios/riesgos-turisticos`,
      label: t('services.travel.title')
    },
  ];

  return (
    <footer className="bg-primary-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <Link to={`${prefix}/`}>
              <img
                src="/images/logo/full_white_nobg.png"
                alt="Confidenza Seguros"
                className="h-12 w-auto"
              />
            </Link>
            <p className="text-primary-200 text-sm">
              {t('footer.tagline')}
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold">{t('footer.quickLinks')}</h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-primary-200 hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold">{t('footer.services')}</h4>
            <ul className="space-y-2">
              {serviceLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-primary-200 hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold">{t('contact.info.title')}</h4>
            <div className="space-y-2 text-primary-200 text-sm">
              <p>{t('contact.info.email')}</p>
              <p>{t('contact.info.phone')}</p>
              <p>{t('contact.info.address')}</p>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-primary-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="text-center md:text-left mb-4 md:mb-0">
            <p className="text-primary-200 text-sm">
              {t('footer.copyright')}
            </p>
          </div>
          <div className="flex space-x-4">
            <Link
              to={isEnglish ? `${prefix}/privacy-policy` : `${prefix}/aviso-de-privacidad`}
              className="text-primary-200 hover:text-white text-sm"
            >
              {t('footer.privacy')}
            </Link>
            {/* Términos y Condiciones intentionally hidden from prod (no page yet). */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
